export const PLAY_BUTTON_CLICK = 'V-UI-UI_EVENT-PLAY_BUTTON_CLICK';
export const PAUSE_BUTTON_CLICK = 'V-UI-UI_EVENT-PAUSE_BUTTON_CLICK';
export const TIME_CHANGE = 'V-UI-UI_EVENT-TIME_CHANGE';
export const VOLUME_CHANGE = 'V-UI-UI_EVENT-VOLUME_CHANGE';
export const FULLSCREEN_BUTTON_CLICK = 'V-UI-UI_EVENT-FULLSCREEN_BUTTON_CLICK';

// KEYBOARD EVENT
export const KEYBOARD_TOGGLE = 'V-UI-UI_EVENT-KEYBOARD_TOGGLE';
export const KEYBOARD_TIME_STEP_BACKWARD =
  'V-UI-UI_EVENT-KEYBOARD_TIME_STEP_BACKWARD';
export const KEYBOARD_TIME_STEP_BACKWARD_DONE =
  'V-UI-UI_EVENT-KEYBOARD_TIME_STEP_BACKWARD_DONE';
export const KEYBOARD_TIME_STEP_FORWARD =
  'V-UI-UI_EVENT-KEYBOARD_TIME_STEP_FORWARD';
export const KEYBOARD_TIME_STEP_FORWARD_DONE =
  'V-UI-UI_EVENT-KEYBOARD_TIME_STEP_FORWARD_DONE';
export const KEYBOARD_VOLUME_UP = 'V-UI-UI_EVENT-KEYBOARD_VOLUME_UP';
export const KEYBOARD_VOLUME_DOWN = 'V-UI-UI_EVENT-KEYBOARD_VOLUME_DOWN';

// ORIGIN EVENT
export const PLAY_BUTTON_CLICK_O = 'V-UI-UI_EVENT-PLAY_BUTTON_CLICK_O';

export const FEEDBACK_SUBMIT = 'V-UI-UI_EVENT-FEEDBACK_SUMMIT';

export default {
  PLAY_BUTTON_CLICK,
  PAUSE_BUTTON_CLICK,
  TIME_CHANGE,
  VOLUME_CHANGE,
  FULLSCREEN_BUTTON_CLICK,

  KEYBOARD_TOGGLE,
  KEYBOARD_TIME_STEP_BACKWARD,
  KEYBOARD_TIME_STEP_BACKWARD_DONE,
  KEYBOARD_TIME_STEP_FORWARD,
  KEYBOARD_TIME_STEP_FORWARD_DONE,
  KEYBOARD_VOLUME_UP,
  KEYBOARD_VOLUME_DOWN,

  PLAY_BUTTON_CLICK_O,
  FEEDBACK_SUBMIT,
};
